import { Menu, MenuItem, Paper, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Palette } from 'Palette';

export const StyledPaper = styled(Paper)<{ className?: string }>(({ theme, className }) => ({
  padding: theme.spacing(4),
  maxWidth: 400,
  textAlign: 'center',
  className: `react-StyledPaper ${className || ''}`.trim(),
}));

export const StyledTextField = styled(TextField)<{ className?: string }>(
  ({ theme, className }) => ({
    marginBottom: theme.spacing(2),
    className: `react-StyledTextField ${className || ''}`.trim(),
  }),
);

export const StyledMenuItem = styled(MenuItem)<{ className?: string }>(({ theme, className }) => ({
  color: Palette.tone1.text,
  fontWeight: 500,
  fontSize: '0.9rem',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1.2, 2),
  className: `react-StyledMenuItem ${className || ''}`.trim(),
  '&:hover': {
    backgroundColor: Palette.tone2.background,
    color: Palette.tone2.text,
  },
}));

export const StyledMenu = styled(Menu)<{ className?: string }>(({ className }) => ({
  '& .MuiPaper-root': {
    backgroundColor: Palette.tone1.background,
    boxShadow: '0px 4px 16px rgba(0,0,0,0.1)',
    borderRadius: 8,
  },
  className: `react-StyledMenu ${className || ''}`.trim(),
}));
